import { ManageOutageFormValue } from './manage-outage.interfaces';

export function createManageOutageFormValue(): ManageOutageFormValue {
  return {
    mstr_entity_id: null,
    mstr_substation_id: null,
    outage_type: '',
    outage_start: '',
    expected_end: '',
    actual_revival: '',
    reason: '',
  };
}
